var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chooser',{staticClass:"budget-chooser",attrs:{"options":_vm.options,"allow-dynamic":true,"dynamic-default-text":"(enter number)","dynamic-default-value":0,"title":"Do you have a budget in mind?"},on:{"input":_vm.onInput},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }